import axios from 'axios';
import URLS from '../util/urls.js';

const state = {
  loginInfo: {
    login: "",
    senha: "",
    imobiliaria: {
      id: ""
    }
  },
  usuarioLogado: {}
}

const mutations = {
  limparUsuarioLogado(state) {
    state.usuarioLogado = {
      id: 0
    }
  },
  atualizarUsuarioLogado(state, payload) {
    state.usuarioLogado = payload;
  }
}

const actions = {
  validarAcesso(context, payload) {
    return axios.post(URLS.VALIDAR_ACESSO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarUsuarioLogado', response.data.item);
          break;
        case "FALHA":
        case "ERRO":
          context.commit('limparUsuarioLogado');
          break;
      }

      return response.data;
    }).catch((error) => {
      context.commit('limparUsuarioLogado');
      return error;
    });
  },

  relogar(context) {
    return axios.post(URLS.VALIDAR_ACESSO, context.state.loginInfo)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarUsuarioLogado', response.data.item);
          break;
        case "FALHA":
        case "ERRO":
          context.commit('limparUsuarioLogado');
          break;
      }
      return response.data;
    }).catch((error) => {
      context.commit('limparUsuarioLogado');
      return error;
    });
  },

  logout(context) {
    return axios.post(URLS.ENCERRAR_SESSAO)
    .then(() => {
      context.commit('limparUsuarioLogado');
      return;
    }).catch((error) => {
      context.commit('limparUsuarioLogado');
      return error;
    });
  }
}

export default {
  state,
  mutations,
  actions
}